import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "10vh",
    marginTop: theme.spacing(0),
  },
  avatar: {
    width: 50,
    height: 50,
    margin: theme.spacing(0),
    backgroundColor: theme.palette.primary.main,
  },
  paper: {
    margin: theme.spacing(0, 8),
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down(700)]: {
      margin: theme.spacing(1.8, 4),
    },
  },
  avatarInProfileSetting: {
    height: "150px",
    width: "150px",
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.down(700)]: {
      height: "60px",
      width: "60px",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0),
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
  },
}));

export default useStyles;
